var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M.854.146a.5.5 0 0 0-.708.708L4.293 5 .146 9.146a.5.5 0 1 0 .708.708L5 5.707l4.146 4.147a.5.5 0 0 0 .708-.708L5.707 5 9.854.854a.5.5 0 0 0-.708-.708L5 4.293z"
  })));
};
export default SvgClose;